import { Component, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { common_urls } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class FooterComponent {
  private router = inject(Router);

  noteOnUseUrl: string = `${common_urls.cwsBaseUrl}/resource/1775484054000/MLJ_CWS_LoginStaticResource/Attachment/Notesonuse.pdf`;
  termOfUseUrl: string = `${common_urls.cwsBaseUrl}/resource/1668755720000/MLJ_CWS_LoginStaticResource/Attachment/ManulifeMypageTermsofUse.pdf`;
  isMobileReg = false;

  ngOnInit() {
    /**condition to display facebook in mobile registration */
    const currentUrl = this.router.url;
    if (currentUrl.includes("/mobile-registration")) {
      this.isMobileReg = true;
    }
    else {
      this.isMobileReg = false;
    }

  }
}
